import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@core/constants';
import { AuthService } from '@core/services';

@Injectable({
  providedIn: 'root'
})
export class SignInChallengeGuard {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.authService.hasPendingSignInChallenge) {
      return true;
    }

    // Reached without a challenge in flight (deep link or refresh) - the server handle is gone,
    // so send the user back to the sign-in page.
    this.router.navigate([APP_ROUTES.BASE]);

    return false;
  }
}
